<script lang="ts" setup>
import { DOCUMENT } from '@pkg/config/sanity/schemas';
import { SINGLETON_DOCUMENT } from '@pkg/config/sanity/singletons';
import { singletonDocId } from '@pkg/sanity-utils/singletonDocId';
import { useSanityData } from '@pkg/sanity-utils/composables/useSanityData';
import Page404Shell from '@pkg/site-chrome/components/Page404.vue';
import { type PageContent } from '~/app/features/cms/types/PageContent';
import { pageById } from '~/apis/sanity/queries/pageById';
import { useSanityPageSeoMeta } from '~/app/composables/useSanityPageSeoMeta';
import ContentRenderer from '~/app/features/cms/components/ContentRenderer.vue';

/**
 * Soft-404 for www — fetch PAGE_404 singleton and render via ContentRenderer.
 * HTTP 404 + shell come from @pkg/site-chrome Page404.
 */
const { locale } = useI18n();
const pageId = singletonDocId(DOCUMENT.PAGES, unref(locale), SINGLETON_DOCUMENT.PAGE_404);
const { data } = await useSanityData<{ page?: PageContent | null }>(pageById, { id: pageId, locale: unref(locale) });

if (data.value?.page?.seoSocial) {
  useSanityPageSeoMeta(data.value.page.seoSocial);
}
</script>

<template>
  <Page404Shell>
    <ContentRenderer :content="data?.page" />
  </Page404Shell>
</template>
